/** @format */

import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

import './header.less';

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navs: [
        {
          text: 'Our Story',
          isActived: false,
          path: '/about',
        },
        {
          text: 'Discovery',
          isActived: false,
          path: '/discovery',
        },
        {
          text: 'Reading List',
          isActived: false,
          path: '/reading-list',
        },
      ],
    };
  }

  handelClick = i => {
    let { navs } = this.state;
    this.props.history.push(navs[i].path);

    const newNavs = navs.map((item, index) => {
      if (index === i) {
        item.isActived = true;
      } else {
        item.isActived = false;
      }
      return item;
    });

    this.setState({
      newNavs,
    });
  };

  render() {
    return (
      <ul>
        {this.state.navs.map((item, index) => (
          <li
            key={item.path}
            className={item.isActived ? 'active-li' : ''}
            onClick={this.handelClick.bind(this, index)}>
            <Link to={item.path}>{item.text}</Link>
          </li>
        ))}
      </ul>
    );
  }
}

export default withRouter(Nav);
